import { authHeader } from "../util/auth-header";
import http from "../util/http-common";

export class RecommendationService {

  static async getAttributes() {
    return http.get("/cfadminvehicleconfig/api/v1/attributes/for-recommendations",{ headers: await authHeader()});
  }

  static async getAttributeValues(data:any) {
    return http.post("/cfadminvehicleconfig/api/v1/attribute-values-query/for-recommendations",data,{ headers: await authHeader()});
  }

  static async createBulkBundle(data:any) {
    return http.post("/cfadminvehicleconfig/api/v1/vehicle-bundles-bulk",data,{ headers: await authHeader()});
  }

  static async deleteBulkBundle(data:any) {
    return http.post("/cfadminvehicleconfig/api/v1/vehicle-bundles-bulk/delete",data,{ headers: await authHeader()});
  }

  static async createBulkOperation(data:any) {
    return http.post("/cfadminvehicleconfig/api/v1/vehicle-operation-bulk",data,{ headers: await authHeader()});
  }

  static async deleteBulkOperation(data:any) {
    return http.post("/cfadminvehicleconfig/api/v1/vehicle-operation-bulk/delete",data,{ headers: await authHeader()});
  }

  static async getModelYearsByModelAndOperation(modelId: any, operationId: any) {
    return http.get(`/cfadminvehicleconfig/api/v1/vehicle-operation-bulk/model-years-for-model-operation?modelId=${modelId}&operationId=${operationId}`, { headers: await authHeader()});
  }

  static async getYearModels(year: string) {
    return http.get(`/cfadminvehicleconfig/api/v1/mmy/model-years-gte?year=${year}`,{ headers: await authHeader()});
  }

  static async cloneVehicles(data:any) {
    return http.post("/cfadminvehicleconfig/api/v1/vehicle/clone-vehicles",data,{ headers: await authHeader()});
  }

  static async copyVehicles(data:any) {
    return http.post("/cfadminvehicleconfig/api/v1/vehicle/copy-vehicle-recommendations",data,{ headers: await authHeader()});
  }

  static async getIolmIntervals() {
    return http.get(`/cfadminvehicleconfig/api/v1/vehicle-driving-conditions-query/iolm-multiple-intervals`,{ headers: await authHeader()});
  }

  static async getAllVehicleBundles(data:any) {
    return http.post("/cfadminvehicleconfig/api/v1/vehicle-bundles-bulk/get-models-by-bundle-year",data,{ headers: await authHeader()});
  }

  static async  getAllModels() {
    return http.get(`/cfadminvehicleconfig/api/v1/vehicle-operation-bulk/models`, { headers: await authHeader()});
  }

  static async getVehicleBundles(bundleId: any, modelId: any, yearId: any) {
    return http.get(`/cfadminvehicleconfig/api/v1/vehicle-bundles-bulk/bundles?bundleId=${bundleId}&modelId=${modelId}&yearId=${yearId}`, { headers: await authHeader()});
  }

  static async saveVehicleBundles(data:any) {
    return http.post("/cfadminvehicleconfig/api/v1/vehicle-bundle",data,{ headers: await authHeader()});
  }

  static async getVehicleOperations(operationId: any, modelId: any, yearIds: any, drivingConditionId: any, intervalId:any) {
    const parameters: any = {};
    const yearIdsArray = Array.isArray(yearIds) ? yearIds : [yearIds];

    parameters.operationId = operationId;
    parameters.modelId = modelId;
    if(yearIdsArray && yearIdsArray.length > 0) parameters.yearIds = yearIdsArray.join(',');
    if(drivingConditionId) parameters.drivingConditionId = drivingConditionId;
    if(intervalId) parameters.intervalId = intervalId;
    if(drivingConditionId && intervalId){
      return http.get(`/cfadminvehicleconfig/api/v1/vehicle-operation-bulk/operations-by-dcond-interval` ,{ params:parameters, headers: await authHeader()});
    }else{
      return http.get(`/cfadminvehicleconfig/api/v1/vehicle-operation-bulk/operations` ,{ params:parameters, headers: await authHeader()});
    }

  }

  static async saveVehicleOperations(data:any) {
    return http.post("/cfadminvehicleconfig/api/v1/vehicle-operations",data,{ headers: await authHeader()});
  }

}

export default RecommendationService;